import { HIDE_TAB } from '../store/schema/PersonalizationConstants';
import SmartComposeStore from '../store/schema/SmartComposeStore';

export default function getInitialStore(): SmartComposeStore {
    return {
        viewState: {
            recipientNames: [],
            recipientListChanged: false,
            currentlyShownSuggestion: null,
            currentlyAnnouncedSuggestion: null,
        },
        recentlyRejectedSuggestionsTelemetry: [],
        allSuggestionsTelemetry: [],
        personalizationSuggestions: {
            tabHintSuggestion: {
                prefer: HIDE_TAB,
                confidenceLevel: 'Low',
            },
        },
        suggestionCache: [],
    };
}
